<h1 mat-dialog-title>{{ 'orderremove.title' | transloco }}</h1>
<div mat-dialog-content>
  <p>{{ 'orderremove.delete1' | transloco }} <b>{{order.eventName}}</b> {{ 'orderremove.delete2' | transloco }}</p>
</div>
<div mat-dialog-actions class="actions">
  <button mat-button (click)="doAction()">{{ 'orderremove.delete' | transloco }}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{ 'orderremove.cancel' | transloco }}</button>
</div>
